import { Node_Type } from 'ricos-schema';
import { decorationsToMarks } from '../decorations-to-marks.js';
import { marksToDecorations } from '../marks-to-decorations.js';
import '../mark-converters.js';
import '../marks/anchor-converter.js';
import '../marks/bold-converter.js';
import '../marks/color-converter.js';
import 'ricos-types';
import '../marks/font-size-converter.js';
import '../marks/italic-converter.js';
import '../marks/link-converter.js';
import '../marks/mention-converter.js';
import '../marks/spoiler-converter.js';
import '../marks/underline-converter.js';

const textConverter = {
  toTiptap: {
    types: [Node_Type.TEXT],
    convert: (node) => {
      var _a;
      if (node.textData.text === "\n") {
        return {
          type: "hardBreak",
          text: "\n",
          marks: [],
          attrs: {
            id: ""
          }
        };
      }
      return {
        type: "text",
        text: node.textData.text,
        marks: decorationsToMarks((_a = node.textData.decorations) != null ? _a : []),
        attrs: {
          id: ""
        }
      };
    }
  },
  fromTiptap: {
    types: ["hardBreak", "text"],
    convert: (node) => {
      if (node.type === "hardBreak") {
        return {
          type: Node_Type.TEXT,
          id: "",
          nodes: [],
          textData: {
            text: "\n",
            decorations: []
          }
        };
      }
      return {
        type: Node_Type.TEXT,
        id: "",
        nodes: [],
        textData: {
          text: node.text || "",
          decorations: marksToDecorations(node.marks || [])
        }
      };
    }
  }
};

export { textConverter };
//# sourceMappingURL=text-converter.js.map
